/*
 * @Author: 张印 hbzyin@163.com
 * @Date: 2023-08-09 15:32:13
 * @LastEditors: 张印 hbzyin@163.com
 * @LastEditTime: 2023-08-18 16:44:25
 * @FilePath: /mall-fe/src/comps/ShopPagePCContent.tsx
 * @Description: PC 端店铺内容展示入口容器组件
 *
 */
import { Fragment } from 'react';
import { ShopModuleCarousel } from './ShopModuleCarousel';
import { ShopModuleChannelPC } from './ShopModuleChannel';
import { ShopModuleCustomPC } from './ShopModuleCustom';
import ShopModuleFloor from './ShopModuleFloor';
import ShopModuleNav from './ShopModuleNav';
import ShopModulePackage from './ShopModulePackage';
import ShopModuleProductList from './ShopModuleProductList';
import { ShopModuleProfilePC } from './ShopModuleProfile';
import { ShopModuleSharingPhotoPC } from './ShopModuleSharingPhoto';
import { ShopModuleSignboardPC } from './ShopModuleSignboard';
import TradeConstraintTip from './TradeConstraintTip';

export default function ShopPagePCContent({ shopData, profileData }) {
  function getModule(item) {
    const { type } = item;
    if (type === 'banner') {
      // 图片轮播
      return <ShopModuleCarousel {...item} />;
    } else if (type === 'channel') {
      // 采购频道
      return <ShopModuleChannelPC item={item} shopData={shopData} />;
    } else if (type === 'floor') {
      // 商品楼层
      return <ShopModuleFloor {...item} shopData={shopData} />;
    } else if (type === 'sharingPhoto') {
      // 宣传图片
      return <ShopModuleSharingPhotoPC item={item} />;
    } else if (type === 'packagePurchase') {
      // 套餐采购
      return <ShopModulePackage shopData={shopData} />;
    } else if (type === 'productList') {
      // 商品列表
      return <ShopModuleProductList {...item} shopData={shopData} />;
    } else if (type === 'custom') {
      // 自定义内容区
      return <ShopModuleCustomPC {...item} />;
    } else if (type === 'outerLink') {
      // 外部链接内容
      return '外部链接内容模块';
    } else if (type === 'profile') {
      // 档案信息
      return <ShopModuleProfilePC profileData={profileData} />;
    } else {
      return null;
    }
  }

  return (
    <>
      <ShopModuleSignboardPC
        jsonConfig={shopData.signboard?.jsonConfig ?? {}}
        shopViewEntity={shopData.shopViewEntity}
      />
      <ShopModuleNav config={shopData.navigationSetting?.jsonConfig ?? {}} shopData={shopData} />
      <TradeConstraintTip shopData={shopData} />
      <div className="module-list-wrap">
        {shopData?.uiConfig?.map((item, index) => (
          <Fragment key={index}>{getModule(item)}</Fragment>
        ))}
      </div>
      <style jsx>{`
        .module-list-wrap {
          padding-bottom: 40px;
          --shop-primary-color: #${shopData?.navigationSetting?.jsonConfig?.navTabColor};
          --shop-primary-text-color: #${shopData?.navigationSetting?.jsonConfig?.navTabTextColor};
        }
      `}</style>
    </>
  );
}
